export default __webpack_public_path__ + "static/media/654.3cf1f810.gif";